
import { Component, Vue, Watch } from "vue-property-decorator";
import TramiteCardComponent from "@/components/Common/Cards/TramiteCardComponent.vue";
import PortalServiciosHeader from "@/components/Tramites/PortalServiciosHeader.vue";
import categoryService from "@/services/category.service";
interface dataCard {
  id: number | any;
  title?: string;
  description?: string;
  tags?: Array<any>;
}

@Component({
  components: {
    PortalServiciosHeader,
    TramiteCardComponent
  }
})
export default class BusquedaTramites extends Vue {
  private searchName: String = this.$route.params.busqueda;
  private pagination: Number = 0;
  private totalPages: Number = 0;
  private tramites: Array<dataCard> = [];

  private mounted() {
    this.loadTramites();
  }
  private async loadTramites() {
    let firstPage: Number = 0;
    if (this.pagination === 0 && this.totalPages === 0) {
      firstPage = 1;
    } else {
      firstPage = this.pagination;
    }
    const response = await categoryService.searchTramitesByName(
      this.searchName,
      firstPage
    );
    this.totalPages = parseInt(response.total_pages);
    this.pagination = parseInt(response.page);
    this.tramites = response.tramites.map((x: any) => {
      return {
        id: x.id,
        title: x.name.toUpperCase(),
        description: x.description,
        slug: x.slug,
        tags: x.tags || []
      };
    });
  }
  private toLink(item: any, target: any) {
    if (item && item != "") {
      window.open(item, target);
    } else {
      return;
    }
  }

  @Watch("$route")
  private routeWatch() {
    this.searchName = this.$route.params.busqueda;
    this.totalPages = 0;
    this.pagination = 0;
    this.loadTramites();
  }

  @Watch("pagination")
  private paginationWatch(newValue: any, oldValue: any) {
    if (oldValue && newValue) {
      this.loadTramites();
    }
  }
}
